export default __webpack_public_path__ + "static/media/tutorial-01.76f25d8c.jpg";